import sideBar from './SideBar/types'
import userInfo from './UserInfo/types'

export default {
  sideBar,
  userInfo
}
